import { FileText, Download } from 'lucide-react'

const reports = [
  {
    id: 1,
    title: "Grade-II Property Detail",
    pdfUrl: "https://www.gwpcs.org/admin/images/eoa_reports/19071721386375619.pdf", 
    year: null
  },
  {
    id: 2,
    title: "Grade-II Property Detail",
    pdfUrl: "https://example.com/grade2_property_detail.pdf", 
    year: null
  },
  {
    id: 3,
    title: "EOA REPORT",
    pdfUrl: "https://example.com/eoa_report_2023-24.pdf", 
    year: "2023-24"
  },
  {
    id: 4,
    title: "EOA REPORT",
    pdfUrl: "https://example.com/eoa_report_2022-23.pdf", 
    year: "2022-23"
  },
  {
    id: 5,
    title: "EOA REPORT",
    pdfUrl: "https://example.com/eoa_report_2021-22.pdf", 
    year: "2021-22"
  }
]

export default function EOAReports() {
  // Function to handle opening PDF in a new tab
  const handleViewPdf = (pdfUrl) => {
    window.open(pdfUrl, '_blank');  // Opens PDF in a new tab
  }

  // Function to handle PDF download
  const handleDownloadPdf = (pdfUrl) => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfUrl.split('/').pop(); // Extract the file name from the URL
    link.click(); // Trigger the download
  }

  return (
    <div className="container mx-auto p-12 space-y-6 sm:space-y-8 bg-gray-100">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-2 sm:space-y-0">
        {/* <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">EOA Reports</h1> */}
      </div>

      <div className="bg-white shadow-lg rounded-lg p-2 overflow-hidden border-4 border-teal-500">
        <div className="bg-teal-500 text-white p-4 rounded-md">
          <h2 className="text-xl sm:text-2xl font-bold">Reports Archive</h2>
        </div>
        <div className=" mt-4 ">
          <div className="overflow-x-auto rounded-md border-2 ">
            <table className="min-w-full table-auto">
              <thead className="bg-muted/50">
                <tr className="bg-gray-300">
                  <th className="w-16 px-4 py-2">S.No.</th>
                  <th className="px-4 py-2">Title</th>
                  <th className="w-32 px-4 py-2">Year</th>
                  <th className="w-24 text-center px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 ">
                {reports.map((report) => (
                  <tr key={report.id} className="hover:bg-teal-100">
                    <td className="px-4 py-2">{report.id}</td>
                    <td className="font-medium px-4 py-2 ">{report.title}</td>
                    <td className="px-4 py-2">{report.year || "-"}</td>
                    <td className="px-4 py-2">
                      <div className="flex justify-center gap-2">
                        {/* View PDF Button */}
                        <button
                          className="h-8 w-8 text-teal-500 hover:text-teal-600"
                          onClick={() => handleViewPdf(report.pdfUrl)}
                        >
                          <FileText className="h-4 w-4" />
                          <span className="sr-only">View PDF</span>
                        </button>
                        
                        {/* Download PDF Button */}
                        <button
                          className="h-8 w-8 text-teal-500 hover:text-teal-600"
                          onClick={() => handleDownloadPdf(report.pdfUrl)}
                        >
                          <Download className="h-4 w-4" />
                          <span className="sr-only">Download PDF</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
